import React, { useMemo } from 'react';
import { useWindowSize } from 'react-use';
import { useClientState } from "../../helper/hooks/useClientState.js";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const SizeSpecificContent = ({
  content,
  breakpoints = {
    sm: 768,
    md: 992,
    lg: 1200
  }
}) => {
  const {
    xs: contentXs,
    sm: contentSm,
    md: contentMd,
    lg: contentLg
  } = content;
  const {
    sm: breakpointSm,
    md: breakpointMd,
    lg: breakpointLg
  } = breakpoints;
  const {
    width
  } = useWindowSize();
  const isClient = useClientState(() => true, false);
  return useMemo(() => {
    const emptyContent = /*#__PURE__*/_jsx(_Fragment, {});
    if (isClient) {
      if (width < breakpointSm) {
        return contentXs ?? contentSm ?? contentMd ?? contentLg ?? emptyContent;
      }
      if (width < breakpointMd) {
        return contentSm ?? contentXs ?? contentMd ?? contentLg ?? emptyContent;
      }
      if (width < breakpointLg) {
        return contentMd ?? contentSm ?? contentXs ?? contentLg ?? emptyContent;
      }
    }
    return contentLg ?? contentMd ?? contentSm ?? contentXs ?? emptyContent;
  }, [contentXs, contentSm, contentMd, contentLg, breakpointSm, breakpointMd, breakpointLg, width, isClient]);
};